import Fetch from "../script/Fetch";

export class AiAdviceService {
    async getIncassoAdvice(ristoranteId: string, startDate: Date, endDate: Date) {
        try {
            const queryParams = new URLSearchParams({
                ristoranteId,
                startDate: startDate.toISOString(),
                endDate: endDate.toISOString()
            });

            const response = await Fetch.doFetch(`/businessintelligence/incasso/ai-advice?${queryParams}`, {
                method: "GET"
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const jsonObject = await response.json();
            console.log("Risposta ricevuta:", jsonObject);
            return jsonObject;

        } catch (error: any) {
            throw new Error("Errore durante il recupero dei dati BI.");
        }
    }

    async getTempisticheAiAdvice(ristoranteId: string, startDate: Date, endDate: Date) {
        try {
            const queryParams = new URLSearchParams({
                ristoranteId,
                startDate: startDate.toISOString(),
                endDate: endDate.toISOString()
            });

            const response = await Fetch.doFetch(`/businessintelligence/tempistiche/ai-advice?${queryParams}`, {
                method: "GET"
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const jsonObject = await response.json();
            console.log("Risposta ricevuta:", jsonObject);
            return jsonObject;

        } catch (error: any) {
            throw new Error("Errore durante il recupero dei dati BI.");
        }
    }

    async getPiattoAiAdvice(ristoranteId: string, startDate: Date, endDate: Date) {
        try {
            const queryParams = new URLSearchParams({
                ristoranteId,
                startDate: startDate.toISOString(),
                endDate: endDate.toISOString()
            });

            const response = await Fetch.doFetch(`/businessintelligence/piatto/ai-advice?${queryParams}`, {
                method: "GET"
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const jsonObject = await response.json();
            console.log("Risposta ricevuta:", jsonObject);
            return jsonObject;

        } catch (error: any) {
            throw new Error("Errore durante il recupero dei dati BI.");
        }
    }

    async getStaffAiAdvice(ristoranteId: string, startDate: Date, endDate: Date) {
        try {
            const queryParams = new URLSearchParams({
                ristoranteId,
                startDate: startDate.toISOString(),
                endDate: endDate.toISOString()
            });

            const response = await Fetch.doFetch(`/businessintelligence/staff/ai-advice?${queryParams}`, {
                method: "GET"
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const jsonObject = await response.json();
            console.log("Risposta ricevuta:", jsonObject);
            return jsonObject;

        } catch (error: any) {
            throw new Error("Errore durante il recupero dei dati BI.");
        }
    }
}